import { render, staticRenderFns } from "./SnackbarCustomize.vue?vue&type=template&id=84fed9e2&"
import script from "./SnackbarCustomize.vue?vue&type=script&lang=js&"
export * from "./SnackbarCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports